(function() {
'use strict';

angular
    .module('searchUnit')
    .directive('datesSearchUnit', datesSearchUnit);

function datesSearchUnit(searchUnitService, sharedSearchUnitService, dateUtil, $window, $route) {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            startDate: '=',
            endDate: '=?',
            startDateLabel: '@',
            endDateLabel: '@',
            isStartTimeApprovedByCustomer: '=?',
            isEndTimeApprovedByCustomer: '=?',
            requiresTimeApproval: '=?',
            enabledDates: '=',
            oneWay: '=',
            outboundOnly: '=',
            returnOnly: '=',
            showTime: '=',
            defaultTime: '=',
            templateOverride: '@',
            areaOverride: '@',
            select: '&',
            resetDuration: '=?'
        },
        templateUrl: (tElement, tAttrs) => `partials/${tAttrs.templateOverride || 'searchunit/dates'}`,
        controller: 'SharedSearchUnit',
        link: _linker
    };

    function _linker(scope) {
        let currentArea;
        const dateLimits = {};
        const halt = scope.$watch('startDate', function(val) {
            if (val === undefined) { return; }
            updateMinDates();
            halt();
        });

        updateCurrentArea(getAreaOverride());
        scope.$watch(getAreaOverride, updateCurrentArea);

        scope.setStartDate = setStartDate;
        scope.setEndDate = setEndDate;
        scope.dateLimits = dateLimits;

        scope.$watch('oneWay', function(value, old) {
            if (value == null || value === old) {
                return;
            }
            searchUnitService.setOneWayFlightEnabled(value);
        });

        scope.$watch('isStartTimeApprovedByCustomer', value => searchUnitService.isStartTimeApprovedByCustomer(currentArea.mode, value));
        scope.$watch('isEndTimeApprovedByCustomer', value => searchUnitService.isEndTimeApprovedByCustomer(currentArea.mode, value));

        function getAreaOverride() {
            return scope.areaOverride || scope.$parent.areaOverride ||
                ($route.current && $route.current.$$route && $route.current.$$route.area);
        }

        function updateCurrentArea(areaOverride) {
            // observation: if areaOverride = 'holidayDeals' then currentArea does not change
            // 'holidayDeals' is not described as an area in area.factory.ts
            currentArea = sharedSearchUnitService.getAreaInfo(areaOverride);
            updateMinDates();
        }

        function updateMinDates() {
            const areaName = currentArea && currentArea.name;
            dateLimits.startDateMin = searchUnitService.getMinStartDate(areaName);
            dateLimits.endDateMin = searchUnitService.getMinEndDate(scope.startDate || dateLimits.startDateMin, areaName);
        }

        function setStartDate(date) {
            if (!date || !currentArea) { return; }

            searchUnitService.startDate(currentArea.mode, date, scope.defaultTime);
            searchUnitService.isStartTimeApprovedByCustomer(currentArea.mode, scope.isStartTimeApprovedByCustomer);
            scope.startDate = date;

            dateLimits.endDateMin = searchUnitService.getMinEndDate(date, currentArea.name);

            if (TRPCONFIG.Domain.DurationEnable || scope.resetDuration === true) {
                const duration = searchUnitService.duration(currentArea.mode);
                const endDateOffset = duration ? duration.value : null;

                scope.endDate = dateUtil.addDays(scope.startDate, endDateOffset || TRPCONFIG.Domain.HolidaysSearchEndOffsetDate, true);
                searchUnitService.endDate(currentArea.mode, scope.endDate);

                let searchDates = sessionStorage.getItem('searchDates');
                if (searchDates) {
                    let searchDatesInfo = JSON.parse(searchDates);
                    scope.endDate = searchDatesInfo.ISOendDate;
                    searchUnitService.endDate(currentArea.mode, scope.endDate);

                    let startStamp = Date.parse(date);
                    let endStamp = Date.parse(scope.endDate);

                    if (startStamp > endStamp) {
                        scope.endDate = dateUtil.addDays(scope.startDate, endDateOffset || TRPCONFIG.Domain.HolidaysSearchEndOffsetDate, true);
                        searchUnitService.endDate(currentArea.mode, scope.endDate);
                    }
                }

            } else {
                //need to refresh the end date because it is possible it has been adjusted
                scope.endDate = searchUnitService.endDate(currentArea.mode);
            }
        }

        function setEndDate(date) {
            if (!date) { return; }

            searchUnitService.endDate(currentArea.mode, date);
            searchUnitService.isEndTimeApprovedByCustomer(currentArea.mode, scope.isEndTimeApprovedByCustomer);
            scope.endDate = date;
        }

        function initDurationInput() {
            scope.options = searchUnitService.getDurationOptions();

            scope.$watch('duration', function() {
                if (scope.duration) {
                    // changed : console.log('$watch CHANGED scope.duration ', scope.duration);
                    searchUnitService.duration(currentArea.mode, scope.duration);
                    scope.endDate = dateUtil.addDays(scope.startDate, searchUnitService.duration(currentArea.mode).value, true);
                    searchUnitService.endDate(currentArea.mode, scope.endDate);
                } else if (searchUnitService.duration(currentArea.mode)) {
                    // retrieve : console.log('$watch RETRIEVE resourceService.SearchUnitDuration ', searchUnitService.duration(currentArea.mode));
                    scope.duration = scope.options[searchUnitService.duration(currentArea.mode).index];
                } else {
                    // init : console.log('$watch INIT scope.duration ', scope.duration);
                    scope.duration = scope.options[0];
                }
            });
        }

        if (TRPCONFIG.Domain.DurationEnable) {
            initDurationInput();
        }
    }
}
})();
